import styled from 'styled-components';

import { media } from '~src/styles/media-templates';

export const ResetButton = styled.div`
  display: flex;
  cursor: pointer;
  color: ${({ theme }) => theme.baseBlue.a10};
  opacity: 0.65;
  &:hover {
    opacity: 1;
  }
`;

export const ResetText = styled.span`
  font-size: 12px;
  font-weight: 600;
  line-height: 25px;
  letter-spacing: 1.25px;
  margin-left: 5px;
  ${media.phone`
    display: none;
  `}
`;

export const InputWrapper = styled.div`
  width: 100%;
`;
